import { Injectable } from '@angular/core';
import { Session } from '../interfaces/session';
import { Company } from '../interfaces/company';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CompanyService {
  private isLoadingSubject$ = new BehaviorSubject<boolean>(false);
  private companiesSub = new BehaviorSubject<Company[] | undefined>(
    this.readCompaniesFromLocalStorage()
  );

  public get isLoading() {
    return this.isLoadingSubject$.value;
  }
  public isLoading$ = this.isLoadingSubject$.asObservable();
  public companies$ = this.companiesSub.asObservable();

  private readCompaniesFromLocalStorage(): Company[] | undefined {
    const session = window.localStorage.getItem('session') as
      | string
      | undefined;

    if (session) {
      return (JSON.parse(session) as Session).companies as unknown as Company[];
    } else {
      return undefined;
    }
  }

  public getCompanies(): Company[] | undefined {
    return this.companiesSub.value;
  }

  /** Company opt-out of the WhatsApp economy mode (text and image); absent = allowed. */
  public isEconomyModeDisabled(companyId: string): boolean {
    return !!this.getCompanies()?.find((company) => company.companyId === companyId)
      ?.disableWhatsappEconomicTextOrImageMode;
  }

  /**
   * Company requires the WhatsApp economy mode: the agent cannot turn it off.
   * Ignored when the company opted out (the flag is kept while the mode is off).
   */
  public isEconomyModeForced(companyId: string): boolean {
    const company = this.getCompanies()?.find((company) => company.companyId === companyId);
    return !!company?.forceWhatsappEconomyMode && !company.disableWhatsappEconomicTextOrImageMode;
  }

  public setCompanies(companies: Company[]) {
    this.companiesSub.next(companies);
  }

  public setLoading(isLoading: boolean) {
    this.isLoadingSubject$.next(isLoading);
  }
}
